import snapshot from './posts.generated.json'

export type BlogPost = {
  title: string
  slug: string
  excerpt: string
  content: string
  category: string
  tags: string[]
  featured: boolean
  seo_title: string
  seo_description: string
  og_image_url: string
  published_at: string
  updated_at: string
  author: {
    name: string
    slug: string
    bio: string
    avatar_url: string
    website_url: string
  }
}

export const blogPosts = snapshot as BlogPost[]
export function blogDatePath(post: Pick<BlogPost, 'published_at'>): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date(post.published_at))
  return ['year', 'month', 'day']
    .map((type) => parts.find((part) => part.type === type)!.value)
    .join('/')
}
export const blogPath = (
  post: Pick<BlogPost, 'published_at' | 'slug'>
): `/blogs/${string}` => `/blogs/${blogDatePath(post)}/${post.slug}`
export const blogPostByPath = Object.fromEntries(
  blogPosts.map((post) => [blogPath(post), post])
)
export const BLOG_PATHS = blogPosts.map(blogPath)
export const BLOG_ARCHIVE_PATHS = [
  ...new Set(
    blogPosts.flatMap((post) => {
      const parts = blogDatePath(post).split('/')
      return [1, 2, 3].map(
        (length) => `/blogs/${parts.slice(0, length).join('/')}` as const
      )
    })
  ),
]
export const blogDate = (date: string) =>
  new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'America/New_York',
  })
export const readingMinutes = (content: string) =>
  Math.max(1, Math.ceil(content.split(/\s+/).length / 220))
